var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "clientlisting"
  }, [_c('b-card', [_c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Shipment Phase")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentPhase),
      expression: "ShipmentPhase"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "shpmentphase",
      "id": "ShipmentPhase",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.ShipmentPhase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShipmentPhase = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("RAD From date ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "fromDate"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("RAD To date ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "name": "toDate"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.datetexterr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("AWB / MPS")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWB),
      expression: "AWB"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('AWB')
    },
    attrs: {
      "type": "text",
      "name": "AWB",
      "id": "AWB",
      "placeholder": "Enter AWB/MPS"
    },
    domProps: {
      "value": (_vm.AWB)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWB = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Shipment UAD Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.shipmentstatuslist,
      "selected-option": _vm.selectedshipmentstatus,
      "name": "shipmentStatus",
      "id": "shipmentStatus",
      "placeholder": "Select Shipment Status"
    },
    on: {
      "select": _vm.selectshipmentStatus
    },
    model: {
      value: (_vm.shipmentStatus),
      callback: function($$v) {
        _vm.shipmentStatus = $$v
      },
      expression: "shipmentStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "margin-left": "7.5rem"
    },
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    on: {
      "click": _vm.searchShipment
    }
  }), _vm._v(" Search")]), _vm._v("   \n                  "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clearForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])], 1)], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Shipment Search")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "shipmentsearch"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("SR No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Consignee phone")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Consignee e-mail")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Delivery Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Delivery Address")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Delivery Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "12%"
    }
  }, [_vm._v("RAD Inscan")]), _vm._v(" "), _c('th', [_vm._v("Re-Schedule Date")]), _vm._v(" "), _c('th', [_vm._v("UAD Marked Status")]), _vm._v(" "), _c('th', [_vm._v("UAD Marked Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tableItems), function(data, index) {
    return [_c('tr', {
      class: {
        "text-primary": true,
        "rowdisable": data.valid == 0 || data.alreadyassign == 1 || data.completebooking == 0 || data.uadreasonmaxedout == 1
      },
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.tableoffset + index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Consigneephone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Consigneeemail))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DeliveryPincode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DeliveryAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DeliveryDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.RADInscan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rescheduledate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.UADStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.UADMarkedCount))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "-btn btn-success",
      attrs: {
        "type": "button",
        "disabled": data.valid == 0 || data.alreadyassign == 1 || data.completebooking == 0 || data.uadreasonmaxedout == 1,
        "title": data.valid == 0 ? "Unable to mark UAD for this shipment. UAD cut-off passed or not in premises" : data.valid == 1 && data.alreadyassign == 1 ? ("Unable to mark UAD.AWB assigned to Trip " + (data.tripid)) : data.completebooking == 0 ? "Please perform complete booking." : data.uadreasonmaxedout == 1 ? "Operations,Consignee and Force Majure UAD marking limit reached." : "Mark UAD"
      },
      on: {
        "click": function($event) {
          _vm.showmarkuad(data.ShippingID, data.Consigneeemail, data.dropname, data.Consigneephone, data.radcutoff, data.uadcutoff, data.totalmps, data.chargedweight, data.uadconsigneemax, data.uadoperationmax, data.uadforcemajuremax, data.RADInscan, data.originaldeliverydate, data.clientname, data.UADMarkedCount)
        }
      }
    }, [_vm._v("Mark UAD")])])])]
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    staticClass: "pagination",
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "xl"
    },
    on: {
      "ok": function($event) {
        _vm.showmarkUAD = false
      }
    },
    model: {
      value: (_vm.showmarkUAD),
      callback: function($$v) {
        _vm.showmarkUAD = $$v
      },
      expression: "showmarkUAD"
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isModalLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isModalLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Mark UAD")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeMarkUAD
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticStyle: {
      "color": "#ff9900"
    }
  }, [_vm._v("Parent AWB:"), _c('span', {
    staticStyle: {
      "color": "#ff9900"
    }
  }, [_vm._v(" " + _vm._s(_vm.UadboxAWB))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Reason")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-info'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.ReasonArr,
      "id": "reason",
      "placeholder": "Select Reason",
      "name": "reason"
    },
    on: {
      "select": _vm.reasonselect
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.reasonerr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Sub Reason")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-info'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.SubReasonArr,
      "id": "subreason",
      "disabled": _vm.subreasondisable,
      "title": _vm.subreasondisable == true ? "Sub-Reason not available for this reason" : "",
      "placeholder": "Select Sub Reason (If any)",
      "name": "subreason"
    },
    on: {
      "select": _vm.selectSubReason
    },
    model: {
      value: (_vm.subreason),
      callback: function($$v) {
        _vm.subreason = $$v
      },
      expression: "subreason"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.subreasonerr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Re-schedule Date(If applicable)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uadrescheduledate),
      expression: "uadrescheduledate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "disabled": _vm.inputboxdisable,
      "title": _vm.inputboxdisable == true ? "Re-Schedule Date not available for this Reason/Sub-Reason" : "",
      "min": _vm.mindate,
      "name": "uadrescheduledate"
    },
    domProps: {
      "value": (_vm.uadrescheduledate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uadrescheduledate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.uadrescheduleerr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right",
      "margin-right": "3px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.markuad
    }
  }, [_vm._v("Submit")]), _vm._v("  \n            "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeMarkUAD
    }
  }, [_vm._v("Cancel")])])])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-494e446e","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/configuration/shipmentSearch/shipmentSearch.component.html
// module id = 1407
// module chunks = 3